"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.detectStatically = void 0;
const static_1 = require("./static");
Object.defineProperty(exports, "detectStatically", { enumerable: true, get: function () { return static_1.detect; } });
//# sourceMappingURL=index.js.map